import { z } from 'zod';

import { FilterConfigSchema, LimitConfigSchema, SortConfigSchema } from '../utils/filterConfig.js';

export const FilterListBlockSchema = z.object({
  originalList: z.string().min(1),
  filterConfig: FilterConfigSchema.optional().transform((obj) => {
    if (!obj?.filterConditions?.length) return undefined;
    return obj;
  }),
  sortConfig: SortConfigSchema.optional().transform((obj) => {
    if (!obj?.fieldToSort) return undefined;
    return obj;
  }),
  limitConfig: LimitConfigSchema.optional(),
});

export type FilterListBlockConfig = z.infer<typeof FilterListBlockSchema>;
